import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { clearPickedPlan, pickedPlan } from '../lib/picked-plan';

const NAME = { builder: 'Builder', growth: 'Growth' } as const;

/**
 * "You picked Builder": the plan chosen on outlevo.com, one click from Billing (which opens with that plan highlighted).
 * Gone once the workspace is on a paid plan, on Billing itself, or when dismissed.
 */
export function PlanPicked({ plan, canPay }: { plan: string; canPay: boolean }) {
  const [gone, setGone] = useState(false);
  const { pathname } = useLocation();
  const picked = pickedPlan();
  if (!picked || gone || !canPay || plan !== 'free') {
    // a paid plan ends the choice for good
    if (picked && plan !== 'free') clearPickedPlan();
    return null;
  }
  if (pathname.startsWith('/billing') || pathname.startsWith('/ops')) return null;
  return (
    <div className="banner" role="status" data-plan-picked={picked}>
      <strong>You picked {NAME[picked]}.</strong> It is not active yet: choose it on Billing when you are ready.{' '}
      <Link className="btn btn-primary btn-sm" to={`/billing?plan=${picked}`}>Choose {NAME[picked]} on Billing</Link>{' '}
      <button type="button" className="link" onClick={() => { clearPickedPlan(); setGone(true); }}>Dismiss</button>
    </div>
  );
}
